/* eslint-disable */
import axios from 'axios';
import router from '@/router';

export const base = process.env.VUE_APP_BASE_URL || '';
export const apiPath = process.env.VUE_APP_API_PATH || '/paysol/index.php';
export const paysol = base + apiPath;
export const uploads = base + '/paysol/uploads/';

let sessionExpiredShown = false;

axios.interceptors.response.use(
  (response) => {
    if (response.data && response.data.success === false && response.data.message === 'Your session has expired.') {
      handleSessionExpired();
      return Promise.reject(new Error('Session expired'));
    }
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) handleSessionExpired();
    return Promise.reject(error);
  }
);

function handleSessionExpired() {
  if (sessionExpiredShown) return;
  sessionExpiredShown = true;
  alert('Your session has expired. Please log in again.');
  clearAuth();
  router.push('/login');
  setTimeout(() => { sessionExpiredShown = false; }, 2000);
}

export function clearAuth() {
  localStorage.removeItem('authToken');
  sessionStorage.removeItem('isLoggedIn');
  sessionStorage.removeItem('userId');
  sessionStorage.removeItem('userName');
  sessionStorage.removeItem('userRole');
  sessionStorage.removeItem('isPlatformOwner');
  sessionStorage.removeItem('tenantId');
  sessionStorage.removeItem('tenantName');
  sessionStorage.removeItem('businessType');
  sessionStorage.removeItem('defaultShopId');
  sessionStorage.removeItem('allowedActions');
}

export function saveAuth(loginData) {
  localStorage.setItem('authToken', loginData.token);
  sessionStorage.setItem('isLoggedIn', '1');
  sessionStorage.setItem('userId', String(loginData.user.id));
  sessionStorage.setItem('userName', loginData.user.name);
  sessionStorage.setItem('userRole', loginData.user.role);
  sessionStorage.setItem('defaultShopId', String(loginData.user.defaultShopId || 0));
  sessionStorage.setItem('isPlatformOwner', loginData.user.isPlatformOwner ? '1' : '0');
  if (loginData.tenant) {
    sessionStorage.setItem('tenantId', String(loginData.tenant.id));
    sessionStorage.setItem('tenantName', loginData.tenant.name);
    if (loginData.tenant.businessType) {
      sessionStorage.setItem('businessType', loginData.tenant.businessType);
    }
  }
  sessionStorage.setItem('allowedActions', JSON.stringify(loginData.allowedActions || []));
}

export const execute = (params, url = paysol) => {
  const token = localStorage.getItem('authToken');
  return axios.post(url, params, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
};

// Alias to match SIMI-TRAC convention used across components
export const executeJson = execute;

export function can(actionKey) {
  const role = sessionStorage.getItem('userRole');
  if (role === 'owner') return true;
  let allowed = [];
  try { allowed = JSON.parse(sessionStorage.getItem('allowedActions') || '[]'); } catch (e) { allowed = []; }
  if (allowed.includes('*')) return true;
  return allowed.includes(actionKey);
}
